import cleanDeep from 'clean-deep';
import { API, graphqlOperation } from 'aws-amplify';

import {
  deleteCompany,
  createCompany,
  updateCompany,
} from '../graphql/mutations';

import {
  listCompanys,
} from '../graphql/queries';

export const createCompanyRecord = (params) => API.graphql(
  graphqlOperation(createCompany, { input: cleanDeep(params) }),
);

export const updateCompanyRecord = (params) => API.graphql(
  graphqlOperation(updateCompany, { input: cleanDeep(params) }),
);

export const deleteCompanyRecord = (params) => API.graphql(
  graphqlOperation(deleteCompany, { input: cleanDeep(params) }),
);

export const getCompanyRecords = (params) => API.graphql(
  graphqlOperation(listCompanys, params),
);
